import React from 'react';
import * as _ from 'lodash';
import { Form } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { VariablesT } from '../../../../types/Company';
import { TransactionT } from '../../../../types/TransactionT';
import { copyObject } from '../../../../utils';
import { JobMode, parseFloatTotal } from '../Job';


import RevenueLineItem from './RevenueLineItem';
import { CogsLineItemT, ExpenseLineItemT, FinancialT, JobT, RevenueLineItemT } from '../../../../types/Job';
import { getRevenueFromTrasactions, revenueExistInTransactions } from '../JobUtils';
import { FinancialObj, RevenueLineItemObj } from '../InitObjectJob';
import { useImmer } from 'use-immer';


export type IRevenueListProps = {
    financial: FinancialT
    job: JobT
    jobMode: JobMode
    sumTotal(lineItems: Array<CogsLineItemT | ExpenseLineItemT | RevenueLineItemT>): number
    addLineItem(lineItemType: string): void
    updateLineItem(lineItemType: string, index: number, value: any): void
    removeLineItem(category: string, index: number): void
    companyVariables: VariablesT
    transactions: Array<TransactionT>
    refresh?(): Promise<void>
    saveJob(): Promise<string>
    updateFinancial(key: string, value: any): void
}

const RevenueList: React.FC<IRevenueListProps> = (props) => {
    const [revenue, setRevenue] = React.useState(FinancialObj.revenue);
    const [itemsInTrasactions, setItemsInTrasactions] = React.useState([]);
    const [revenueItems, setRevenueItems] = useImmer([]);


    React.useEffect(() => {
        if (!_.isEqual(props.financial.revenue, revenue)) {
            setRevenue(props.financial.revenue)
        }
    }, [props.financial.revenue]);

    React.useEffect(() => {

        const revenueClone = revenue
        const revenueItemsClone: Array<RevenueLineItemT> = revenueClone && revenueClone.lineItems ? copyObject(revenueClone.lineItems) : []
        if (revenueItemsClone != revenueItems) {
          
            setRevenueItems(revenueItemsClone)
        }

    }, [revenue]);


    React.useEffect(() => {
        // console.log("financial->cogs",financial.cogs)
        setItemsInTrasactions(getRevenueFromTrasactions(revenueItems, props.transactions))
    }, [props.transactions]);

    const removeLineItem = (category: string, index: number) => {
        let cloneRevenue = copyObject(revenue)
        let lineItems = copyObject(cloneRevenue.lineItems);
        const filteredItems = lineItems.slice(0, index).concat(lineItems.slice(index + 1, lineItems.length))
        if (filteredItems.length <= 0) {
            let item = copyObject(RevenueLineItemObj)
            filteredItems.push(item)
        }
        cloneRevenue.isDirty = true
        cloneRevenue.lineItems = filteredItems;
        setRevenueItems(filteredItems)
        setRevenue(cloneRevenue)
        props.updateFinancial('revenue', cloneRevenue)

    }

    const updateLineItem = (lineItemType: string, index: number, lineItem: CogsLineItemT): void => {
        let cloneRevenue = copyObject(revenue)
     
        cloneRevenue.lineItems[index] = lineItem
        setRevenueItems(cloneRevenue.lineItems)
        setRevenue(cloneRevenue)
        props.updateFinancial('revenue', cloneRevenue)
    }
  
    return (
        <>

            <h4>Revenue</h4>
            {props.jobMode == "edit" && itemsInTrasactions.map((lineItem, index) => {

                return (
                    <RevenueLineItem
                        job={props.job}
                        isPaid={true}
                        companyVariables={props.companyVariables}
                        key={index}
                        index={index}

                        removeLineItem={removeLineItem}
                        revenueLineItem={lineItem}
                        updateLineItem={updateLineItem}
                        saveJob={props.saveJob}
                        refresh={props.refresh} />
                )
            })}
            {revenueItems.map((lineItem: RevenueLineItemT, index: number): JSX.Element => {
                if (revenueExistInTransactions(lineItem, props.transactions)) {
                    return null
                }
                return (
                    <RevenueLineItem
                        job={props.job}
                        isPaid={(lineItem.paid) ? true : false}
                        companyVariables={props.companyVariables}
                        key={index}
                        index={index}

                        removeLineItem={removeLineItem}
                        revenueLineItem={lineItem}
                        updateLineItem={updateLineItem}
                        saveJob={props.saveJob}
                        refresh={props.refresh}
                    />
                )
            })}
            <span style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr 1fr 1fr 1fr 0.1fr' }}>
                <span>
                    <Button
                        onClick={(): void => { props.addLineItem('revenue') }}
                        variant='light'>
                        Add Line Item
                    </Button>
                </span>


                <span></span>
                <span></span>
                <span></span>
                <span>
                    <Form.Label><strong>Total, $</strong></Form.Label>
                    <Form.Control
                        className='input-material'
                        disabled
                        // @ts-ignore
                        value={`${parseFloatTotal(props.sumTotal([...revenueItems.filter((item) => !revenueExistInTransactions(item, props.transactions)), ...itemsInTrasactions]))}`} />
                </span>
            </span>
        </>
    );
}

export { RevenueList }